import React, { useContext } from "react";
import { BsSuitHeartFill } from "react-icons/bs";
import { GiReturnArrow } from "react-icons/gi";
import { FaLightbulb, FaShoppingCart } from "react-icons/fa";
import { MdOutlineLabelImportant } from "react-icons/md";
import Image from "../../designLayouts/Image";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../../redux/orebiSlice";
import { formatPrice } from "../../../constants/funciones";
import { useFavorites } from "../../../context/FavoritesContext";
import { UserConfigContext } from "../../../context/UserConfigContext";

const Product = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { favorites, toggleFavorite } = useFavorites();
  const { configEcommerce } = useContext(UserConfigContext);

  const idString = (name) =>
    String(name).toLowerCase().replace(/\s+/g, "").replace(/[^\w-]/g, "");

  const rootId = idString(props.Descripcion);
  const isFavorite = favorites.some((f) => f.codigo === props.codigo);
  const finalPrice = props.PrecioOferta > 0 ? props.PrecioOferta : props.PrecioLista;
  const showStockMessage = Boolean(configEcommerce?.con_sin_stock && props.stock_mensaje);
  const stockMessageStatus = (() => {
    const message = String(props.stock_mensaje || "").toLowerCase();
    if (message.includes("agotado") || message.includes("sin stock")) return "danger";
    if (message.includes("bajo") || message.includes("poco") || message.includes("limitado")) return "warning";
    return "success";
  })();
  const stockMessageClass = {
    danger: "text-red-600",
    warning: "text-amber-500",
    success: "text-emerald-600",
  }[stockMessageStatus];

  const handleProductDetails = () => {
    navigate(`/product/${rootId}`, { state: { item: props } });
  };

  return (
    <div className="group flex h-full flex-col overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
      <div className="relative">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            toggleFavorite(props);
          }}
          className={`absolute right-3 top-3 z-10 flex h-10 w-10 items-center justify-center rounded-full border border-white/70 bg-white/90 shadow-sm backdrop-blur transition ${
            isFavorite ? "text-emerald-600" : "text-gray-400 hover:text-rose-500"
          }`}
          aria-label={isFavorite ? "Eliminar de favoritos" : "Agregar a favoritos"}
        >
          <BsSuitHeartFill />
        </button>

        <div
          className="relative flex h-72 cursor-pointer items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-white to-slate-100 p-6"
          onClick={handleProductDetails}
        >
          <Image
            className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-105"
            imgSrc={props.img}
          />

          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/10 to-transparent opacity-0 transition duration-300 group-hover:opacity-100" />
        </div>

        <div className="absolute inset-x-3 bottom-3 translate-y-4 opacity-0 transition duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <div className="grid grid-cols-3 gap-2 rounded-2xl bg-white/92 p-2 shadow-lg backdrop-blur">
            <button
              type="button"
              className="flex items-center justify-center rounded-xl border border-gray-200 px-3 py-2 text-gray-600 transition hover:border-gray-300 hover:bg-gray-50 hover:text-primeColor"
              title="Compartir"
            >
              <GiReturnArrow />
            </button>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                dispatch(addToCart({ ...props, quantity: 1 }));
              }}
              className="flex items-center justify-center rounded-xl bg-gray-900 px-3 py-2 text-white transition hover:bg-black"
              title="Agregar al carrito"
            >
              <FaShoppingCart />
            </button>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleProductDetails();
              }}
              className="flex items-center justify-center rounded-xl border border-gray-200 px-3 py-2 text-gray-600 transition hover:border-gray-300 hover:bg-gray-50 hover:text-primeColor"
              title="Ver detalles"
            >
              <MdOutlineLabelImportant className="text-lg" />
            </button>
          </div>
        </div>
      </div>

      <div
        className="flex flex-1 cursor-pointer flex-col gap-3 border-t border-gray-100 px-5 py-5"
        onClick={handleProductDetails}
      >
        <div className="flex items-start justify-between gap-3">
          <span className="inline-flex rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-slate-600">
            {props.codigo}
          </span>
          {props.PrecioOferta > 0 && (
            <span className="rounded-full bg-rose-50 px-3 py-1 text-xs font-semibold text-rose-600">
              Oferta
            </span>
          )}
        </div>

        <div
          className="min-h-[3.5rem] text-base font-semibold leading-snug text-gray-900"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {props.Descripcion}
        </div>

        <div className="mt-auto flex items-end justify-between gap-3">
          <div className="text-sm">
            <p className="text-xs font-medium uppercase tracking-wide text-gray-400">Precio</p>
            <div className="mt-1">
              {props.PrecioOferta > 0 && (
                <span className="mr-2 text-sm text-gray-400 line-through">
                  ${formatPrice(props.PrecioLista)}
                </span>
              )}
              <span className="text-xl font-bold text-primeColor">
                ${formatPrice(finalPrice)}
              </span>
            </div>
          </div>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              dispatch(addToCart({ ...props, quantity: 1 }));
            }}
            className="inline-flex items-center gap-2 rounded-full bg-gray-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-black"
          >
            <FaShoppingCart />
            Agregar
          </button>
        </div>

        <div className="flex items-center justify-between border-t border-dashed border-gray-200 pt-3 text-sm text-gray-500">
          {showStockMessage ? (
            <span className={`inline-flex min-w-0 items-center gap-1.5 font-semibold ${stockMessageClass}`}>
              <FaLightbulb className="shrink-0" />
              <span className="truncate">{props.stock_mensaje}</span>
            </span>
          ) : (
            <span>Ver detalle completo</span>
          )}
          {props.PrecioOferta > 0 ? (
            <span className="font-medium text-rose-600">Precio promocional</span>
          ) : (
            <span className="font-medium text-slate-600">Precio de lista</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Product;
